/**
 * MediaSource helper
 */

export function getMediaSource () {
  if (typeof window !== 'undefined') {
    return window.MediaSource || window.WebKitMediaSource;
  }
}



// WEBPACK FOOTER //
// ./src/utils/mediasource-helper.js


// WEBPACK FOOTER //
// webpack:///src/utils/mediasource-helper.js